<template>
  <div :class="['OfferCardTag', type]">
    <div class="safe">
      <div class="overline"><slot /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfferCardTag',
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return [
          'info',
          'negative',
          'positive',
          'positive-light',
          'error',
          'warning',
          'warning-light',
        ].includes(value)
      },
    },
  },
}
</script>

<style lang="scss">
.OfferCardTag {
  border-radius: 12px 12px 0 0;
  padding: 0 8px 0 8px;
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-transform: none;

  &.neutral,
  &.NEUTRAL {
    background-color: $color-neutral-dark;
  }

  &.positive,
  &.POSITIVE {
    background-color: $color-feedback-positive;

    & > .safe {
      .overline {
        color: $color-white-high;
      }
    }
  }

  &.positive-light,
  &.POSITIVE-LIGHT {
    background-color: $color-feedback-positive-light;
  }

  &.error,
  &.ERROR {
    background-color: $color-feedback-negative-light;
  }

  &.warning,
  &.WARNING {
    background-color: $color-feedback-warning;
  }

  &.warning-light,
  &.WARNING-LIGHT {
    background-color: $color-feedback-warning-light;
  }

  & > .safe {
    padding: 4px 0 4px 0;
    display: flex;
    flex-direction: row;
    gap: 0;
    align-items: flex-start;
    justify-content: flex-start;
    flex: 1;
    position: relative;

    & > .overline {
      color: $color-black-high;
      @include overline;
      text-align: center;
      position: relative;
      align-self: stretch;
      flex: 1;
      text-transform: none;
    }
  }
}
</style>
